import { Component, Injector, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GridComponent } from 'src/app/components/grid/grid.component';
import { StatusJustificativaDaoService } from 'src/app/dao/status-justificativa-dao.service';
import { UsuarioDaoService } from 'src/app/dao/usuario-dao.service';
import { StatusJustificativa } from 'src/app/models/status-justificativa.model';
import { PageListBase } from 'src/app/modules/base/page-list-base';
import { NavigateService } from 'src/app/services/navigate.service';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.scss']
})

export class StatusListComponent extends PageListBase<StatusJustificativa,StatusJustificativaDaoService> {
    @ViewChild(GridComponent, { static: false }) public grid?: GridComponent;

    public statusDao : StatusJustificativaDaoService;
    public usuarioDao : UsuarioDaoService;
    public params?: any;
    public id : String ="";
    public field : String="";
 
    constructor(public injector: Injector) {
      super(injector, StatusJustificativa, StatusJustificativaDaoService);
      this.join = ["usuario", "atividade","plano_trabalho","plano_trabalho_consolidacao","plano_entrega"];
      this.orderBy = [['created_at', 'asc']];
      this.go = this.injector.get<NavigateService>(NavigateService);
      this.statusDao = injector.get<StatusJustificativaDaoService>(StatusJustificativaDaoService);
      this.usuarioDao = injector.get<UsuarioDaoService>(UsuarioDaoService);
      this.title = "Histórico de Status ";
      this.filter = this.fh.FormBuilder({
        plano_entrega_id: { default: "" }
      });
    }

    public ngOnInit() {
      super.ngOnInit();
      this.id = this.metadata?.params.id;
      this.field = this.metadata?.params.field;
      switch (this.field){
          case "plano_entrega_id":
            this.title = this.title + "do Plano de Entrega";
          break;
          case "plano_trabalho_id":
            this.title = this.title + "do Plano de Trabalho";
          break;
          case "atividade_id":
            this.title = this.title + "da Atividade";
          break;
          case "plano_trabalho_consolidacao_id":
            this.title = this.title + "do Ciclo Avaliativo";
          break;        
      }
    }

    public getUsuario(id:string){}

    public filterWhere = (filter: FormGroup) => {
      let result: any[] = [];
      let form: any = filter.value;
      result.push([this.field, "==",this.id]);
      return result;
    }

}
